import { getStaticPath } from '@/api/utils/tool'
// 播放声音
export function playSound (url) {
  let audio = new Audio(url)
  audio.play()
}

  
// 播放成功声音
export function playSoundSuccess () {
  const staticPath = getStaticPath()
  playSound(`${staticPath}successSound.wav`)
}
  
// 播放失败声音
export function playSoundFail () {
  const staticPath = getStaticPath()
  playSound(`${staticPath}Final_Buzz_Voice.mp3`)
}
export function playNotification () {
  const staticPath = getStaticPath()
  playSound(`${staticPath}notification.mp3`)
}
// 播放危险品提示声音
export function playSoundDangerous() {
  const staticPath = getStaticPath()
  playSound(`${staticPath}dangerousGoodsSound.mp3`)
}